export default __webpack_public_path__ + "assets/6891ae28817ad881aa0ef3e7b22467e0.svg";